/* eslint-disable */
import React, { Component } from 'react';
import CustomSnackbar from './../shared/custom_snackbar';
import { Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { resetBeneficiarioState } from '@store/actions/index';
import m from '@utils/strings';

class AreaResultadoNaoAutorizado extends Component {
    state = {
        copied: false
    }

    resetBeneficiarioState = () => {
        this.props.setInitialFieldsState();
        this.props.resetBeneficiarioState();
    }

    buildMensagemErro = (beneficiario) => {
        let mensagem_erro = ""
        const { data: { elegibilidade, solicitacaoProcedimento } } = beneficiario
        if (elegibilidade != null && elegibilidade.CodigoMotivoNegativa != null && elegibilidade.DescricaoMotivoNegativa !== "NULL") {
            let cod = elegibilidade.CodigoMotivoNegativa;
            cod = cod.replace(/([\a-zA-Z])/g, '');
            return mensagem_erro += cod + ' - ' + elegibilidade.DescricaoMotivoNegativa;
        }
        else if (solicitacaoProcedimento != null && solicitacaoProcedimento.CodigoMotivoNegativa != null && solicitacaoProcedimento.DescricaoMotivoNegativa !== "NULL") {
            let cod = solicitacaoProcedimento.CodigoMotivoNegativa;
            cod = cod.replace(/([\a-zA-Z])/g, '');
            return mensagem_erro += cod + ' - ' + solicitacaoProcedimento.DescricaoMotivoNegativa;
        }
        else if (solicitacaoProcedimento != null && solicitacaoProcedimento.Procedimento != null && solicitacaoProcedimento.Procedimento.CodigoMotivoGlosa != null){
            let cod = solicitacaoProcedimento.Procedimento.CodigoMotivoGlosa;
            cod = cod.replace(/([\a-zA-Z])/g, '');
            return mensagem_erro += cod + ' - ' + solicitacaoProcedimento.Procedimento.DescricaoMotivoGlosa;
        }
        else {
            return mensagem_erro = m.TELA_CONSULTA_PRONTO_SOCORRO.MENSAGEM_ERRO_GENERICO_AUTORIZACAO
        }
    }

    render() {
        const { beneficiario } = this.props
        const mensagem_erro = this.buildMensagemErro(beneficiario)
        return (
            <div className={"div-area-resultado-autorizacao"}>
                <label id={"label-erro-servico"}>
                    {m.TELA_CONSULTA_PRONTO_SOCORRO.MENSAGEM_ATENDIMENTO_NAO_AUTORIZADO}
                </label>
                <div className={"div-separador-top-10"}>
                    <label id={"label-usuario-inelegivel"}>
                        {mensagem_erro}
                    </label>
                </div>
                <div className={"div-separador-top-bottom-25"}>
                    <hr className={"hr-class"} />
                </div>
                <div className={"div-separador-top-10"}>
                    <Button
                        onClick={this.resetBeneficiarioState}
                        className={"btn-default-cemig"}>
                        {m.TELA_CONSULTA_PRONTO_SOCORRO.LABEL_NOVO_ATENDIMENTO} (ENTER)
                    </Button>
                </div>
                <CustomSnackbar
                    setClick={click => this.clickChild = click}
                    variant="success"
                    duration={1000}
                    content={m.TELA_CONSULTA_PRONTO_SOCORRO.NOTIFICACAO_MENSAGEM_COPIADA}
                />
            </div>
        )
    }
}

export default connect(null, { resetBeneficiarioState })(AreaResultadoNaoAutorizado)